const findOccurrencesStartIndexes = (inputString: string, searchString: string) => {
  if (!searchString || !inputString) return [];

  // Define regex pattern to match words and symbols
  const pattern = /[a-zA-Z0-9]+|[^a-zA-Z0-9]+/g;

  const numberOfWordsInSearchString = searchString.match(pattern)?.length || 0;

  // Use regex pattern to extract words and symbols from the input string
  const parts = inputString.match(pattern) || [];
  const searchStringLower = searchString.toLowerCase();

  const startIndexes = [];

  for (let i = 0; i < parts.length; ) {
    const concatenatedWord = parts.slice(i, i + numberOfWordsInSearchString).join("");

    if (concatenatedWord.toLowerCase() === searchStringLower) {
      // Calculate the start index of the matched word in the original inputString
      const startIndex = parts.slice(0, i).join("").length;
      startIndexes.push(startIndex);
      i += numberOfWordsInSearchString;
    } else {
      i++;
    }
  }

  return startIndexes;
};

const getPositionOfOccurrence = (
  inputString: string,
  searchString: string,
  searchStringStartIndex: number
) => {
  const occurrenceIndexes = findOccurrencesStartIndexes(inputString, searchString);

  return occurrenceIndexes.findIndex(
    (occurrenceStartIndex) => occurrenceStartIndex === searchStringStartIndex
  );
};

/**
 * Capitalizes the first letter of a string
 * @param str The string to capitalize
 * @returns The capitalized string or undefined if input is nullish
 */
const capitalize = (str?: string | null): string | undefined => {
  if (!str) return undefined;
  return str.charAt(0).toUpperCase() + str.slice(1);
};

export { findOccurrencesStartIndexes, getPositionOfOccurrence, capitalize };
